"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const styled_components_1 = __importDefault(require("styled-components"));
exports.default = styled_components_1.default.div `
    width: 50%;
    @media screen and ${constants_1.Device.tablet} {
        width: 75%;
    }
    @media screen and ${constants_1.Device.mobileL} {
        width: 100%;
    }
    input {
        display: block;
        margin: 1em auto 2em;
        padding: 1em;
        width: 100%;
        border: 1px solid $siteBlockBorder;
        background-color: transparent;
        font-weight: 700;
        font-size: 1em;
        text-align: center;
        text-transform: uppercase;
        @media screen and ${constants_1.Device.mobileL} {
            font-size: 16px;
            line-height: 16px;
        }
        p.centered {
            @media screen and ${constants_1.Device.mobileL} {
                text-align: left;
            }
        }
    }
    .errorMessage {
        display: block;
        margin-bottom: 2em;
        text-align: center;
        clear: both;
    }
`;
//# sourceMappingURL=ValidateStageStyled.js.map